import React, { useState } from "react";
import "./DepartmentSchemesPage.css";

// Import placeholder images
import agriBuilding from "../assets/images/agri_building.png";
import officer1 from "../assets/images/officer1.png";
// import healthBuilding from "./images/healthcare.jpg";
import officer2 from "../assets/images/officer2.png";

const departmentsData = [
  {
    id: 1,
    name: "Agriculture Department",
    officer: "Mr. Rajesh Kumar",
    officerPhoto: officer1,
    departmentPhoto: agriBuilding,
    description:
      "The Agriculture Department focuses on improving farming techniques, crop management, and providing support to farmers.",
    contact: {
      phone: "+91 98765 43210",
      email: "agri@nimgaon.gov.in",
      website: "https://agriculture.nimgaon.gov.in",
    },
    schemes: [
      {
        title: "Farmer Subsidy Scheme",
        description:
          "Provides financial support for farmers purchasing seeds, fertilizers, and machinery.",
      },
      {
        title: "Organic Farming Promotion",
        description:
          "Encourages farmers to adopt organic farming practices through training and incentives.",
      },
    ],
  },
  {
    id: 2,
    name: "Health Department",
    officer: "Dr. Sunita Patil",
    officerPhoto: officer2,
    departmentPhoto: "../images/healthcare.jpg ",
    description:
      "The Health Department manages public health services, hospitals, and preventive health programs in the region.",
    contact: {
      phone: "+91 91234 56789",
      email: "health@nimgaon.gov.in",
      website: "https://health.nimgaon.gov.in",
    },
    schemes: [
      {
        title: "Free Health Checkup Scheme",
        description:
          "Provides free health checkups at government hospitals and health centers.",
      },
      {
        title: "Vaccination Drive",
        description:
          "Ensures vaccination for children and adults for preventable diseases.",
      },
    ],
  },
];

const allSchemes = [
  {
    title: "Farmer Subsidy Scheme",
    department: "Agriculture Department",
    description:
      "Provides financial support for farmers purchasing seeds, fertilizers, and machinery.",
  },
  {
    title: "Organic Farming Promotion",
    department: "Agriculture Department",
    description:
      "Encourages farmers to adopt organic farming practices through training and incentives.",
  },
  {
    title: "Free Health Checkup Scheme",
    department: "Health Department",
    description:
      "Provides free health checkups at government hospitals and health centers.",
  },
  {
    title: "Vaccination Drive",
    department: "Health Department",
    description:
      "Ensures vaccination for children and adults for preventable diseases.",
  },
];

const DepartmentSchemesPage = () => {
  const [activeTab, setActiveTab] = useState("department");
  const [selectedDept, setSelectedDept] = useState(departmentsData[0].id);

  const currentDept = departmentsData.find((d) => d.id === selectedDept);

  return (
    <div className="dept-schemes-container">
      {/* Tabs */}
      <div className="tabs">
        <button
          className={activeTab === "department" ? "active" : ""}
          onClick={() => setActiveTab("department")}
        >
          Department
        </button>
        <button
          className={activeTab === "schemes" ? "active" : ""}
          onClick={() => setActiveTab("schemes")}
        >
          Schemes Only
        </button>
      </div>

      {/* Content */}
      {activeTab === "department" && (
        <div className="department-tab">
          {/* Department selector */}
          <select
            value={selectedDept}
            onChange={(e) => setSelectedDept(Number(e.target.value))}
          >
            {departmentsData.map((dept) => (
              <option key={dept.id} value={dept.id}>
                {dept.name}
              </option>
            ))}
          </select>

          {/* Department main photo */}
          <div
            className="department-photo"
            key={`deptPhoto-${currentDept.id}`}
          >
            <img
              src={currentDept.departmentPhoto}
              alt={`${currentDept.name} Building`}
              className="fade-in"
            />
          </div>

          {/* Department info */}
          <div className="department-info" key={`deptInfo-${currentDept.id}`}>
            <h2 className="fade-in">{currentDept.name}</h2>

            <div className="officer-info slide-in-left">
              <img
                src={currentDept.officerPhoto}
                alt={currentDept.officer}
                className="officer-photo"
              />
              <p>
                <strong>Main Officer:</strong> {currentDept.officer}
              </p>
            </div>

            <p>{currentDept.description}</p>
            <p>
              <strong>Contact:</strong>{" "}
              <a href={`tel:${currentDept.contact.phone}`}>
                {currentDept.contact.phone}
              </a>{" "}
              |{" "}
              <a href={`mailto:${currentDept.contact.email}`}>
                {currentDept.contact.email}
              </a>{" "}
              |{" "}
              <a href={currentDept.contact.website} target="_blank">
                Website
              </a>
            </p>
          </div>

          {/* Department schemes */}
          <div className="schemes-list">
            <h3>Schemes Offered:</h3>
            {currentDept.schemes.map((scheme, idx) => (
              <div key={idx} className="scheme-card fade-in-up">
                <h4>{scheme.title}</h4>
                <p>{scheme.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === "schemes" && (
        <div className="schemes-tab">
          <h3>All Government Schemes</h3>
          <div className="all-schemes-grid">
            {allSchemes.map((scheme, idx) => (
              <div key={idx} className="scheme-card fade-in-up">
                <h4>{scheme.title}</h4>
                <p>
                  <strong>Department:</strong> {scheme.department}
                </p>
                <p>{scheme.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DepartmentSchemesPage;
